export default __webpack_public_path__ + "static/media/ic_delete_forever_white.14bd4311.png";